import { actionTypes } from "react-redux-form";
import { Reducer } from "redux";
import { ResourceLoadingState, SingleResourceLoadingState } from "../../common/store/stateHelpers";
import { FeedbackModel } from "../models/FeedbackModels";
import { PagingFilter, PagedResultData } from "../../common/models/PagingModels";

export enum ActionType {
    RequestFeedback = "FEEDBACK/REQUEST_FEEDBACK",
    ReceivedFeedback = "FEEDBACK/RECEIVED_FEEDBACK",
    SetRead = "FEEDBACK/SET_READ"
}

export interface RequestFeedbackAction {
    type: ActionType.RequestFeedback,
    paging?: PagingFilter
}

interface ReceivedFeedbackAction {
    type: ActionType.ReceivedFeedback
    data: PagedResultData<FeedbackModel>
}

export interface SetReadAction {
    type: ActionType.SetRead,
    feedbackId: string;
    paging?: PagingFilter;
}

export const actionCreators = {
    requestFeedback: (paging?: PagingFilter) => <RequestFeedbackAction>{ type: ActionType.RequestFeedback, paging },
    receivedFeedback: (data?: PagedResultData<FeedbackModel>) => <ReceivedFeedbackAction>{ type: ActionType.ReceivedFeedback, data },
    setRead: (feedbackId: string, paging?: PagingFilter) => <SetReadAction>{ type: ActionType.SetRead, feedbackId, paging }
}

export type FeedbackState = SingleResourceLoadingState<PagedResultData<FeedbackModel>>;

const initialState: FeedbackState = {
    isLoading: false,
    data: undefined
}

type FeedbackAction = RequestFeedbackAction | ReceivedFeedbackAction;

export const reducer: Reducer<FeedbackState> = (state: FeedbackState, action: FeedbackAction) => {
    switch (action.type) {
        case ActionType.RequestFeedback:
            return {
                data: undefined,
                isLoading: true
            }
        case ActionType.ReceivedFeedback:
            return {
                data: action.data,
                isLoading: false
            }
        default:
            const exhaustiveCheck: never = action;
    }

    return state || initialState;
}




// WEBPACK FOOTER //
// ./src/admin/store/feedbackStore.ts